import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import SelectInput from '../layout/Select';

const options = [10, 20, 30, 40, 50];

const FlexDiv = styled.div`
  align-items: center;
  display: flex;
`;

const MargedDiv = styled.div`
  margin-left: 3px;
  margin-right: 3px;
`;

const Select = ({t, value, onChange}) => {
  return (
    <FlexDiv>
      <MargedDiv>{t('datatable.display')} : </MargedDiv>
      <MargedDiv>
        <SelectInput onChange={onChange} name="displayNb" value={value} absolute>
          {options.map((option, index) => <option key={index} value={option}>{option}</option>)}
        </SelectInput>{' '}
      </MargedDiv>
      <MargedDiv>{t('datatable.elements')}</MargedDiv>
    </FlexDiv>
  );
};

Select.propTypes = {
  t: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withTranslation('common')(Select);
